import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=445db8bb&scoped=true"
import script from "./CustomerInformation.vue?vue&type=script&lang=js"
export * from "./CustomerInformation.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=445db8bb&prod&scoped=true&lang=css"
import style1 from "./CustomerInformation.vue?vue&type=style&index=1&id=445db8bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445db8bb",
  null
  
)

export default component.exports